import MDXProvider from './MDXProvider';

export default MDXProvider;
